import React from "react";
import {Link} from "react-router-dom";

export default function RefundPage(){
    return(
        <div className="custor-welcome" style={{maxWidth:"900px",margin:"0 auto"}}>
            <h1>Refund Policy</h1>
            <p>Last updated: September 2026</p>

            <h2>1. Subscriptions</h2>
            <p>Custor offers subscription plans that provide access to paid features of the service. Subscription prices and billing periods are shown before purchase.</p>

            <h2>2. Cancellation</h2>
            <p>You may cancel your subscription according to the options available through your Custor account or the customer portal provided by our payment provider.</p>

            <h2>3. Refunds</h2>
            <p>Refund requests are considered on a case-by-case basis, subject to applicable law and the terms of the relevant subscription.</p>

            <h2>4. Service Problems</h2>
            <p>If you experience a significant technical problem that prevents you from using a paid feature, please contact us and provide details of the issue. We will review the situation and determine an appropriate resolution.</p>

            <h2>5. Contact</h2>
            <p>For refund or billing questions, please contact us through the contact information provided on the Custor website.</p>

            <div style={{marginTop:"30px"}}>
                <Link to="/terms">Terms of Service</Link>{" · "}
                <Link to="/privacy">Privacy Policy</Link>{" · "}
                <Link to="/login">Back to Custor</Link>
            </div>
        </div>
    );
}